module.exports = __webpack_public_path__ + "static/media/login_left_bg.ed746de5.png";